import { Box } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';

import { MetaHead } from 'components/MetaHead/MetaHead';
import { HeaderWithOptions } from 'components/Header';
import { Footer } from 'components/Footer';
import { PartnerBanks } from 'components/PartnerBanks/PartnerBanks';
import Advantages from 'components/Advantages';
import BottomNavigationMap from 'components/BottomNavigation/BottomNavigationMap';
import CTAStepExplanations from 'components/CTAStepExplanations';
import { TrustBanner } from 'components/TrustBanners/TrustBanner';
import { Divider } from 'components/Divider';
import LegalText from 'components/LegalText';
import { advantages } from 'legacy/data/advantages';
import { withOptimizelyProps } from 'lib/optimizely';
import { Stage } from 'components/Stage/Stage';
import { ListIcons, SellingPointsPosition } from 'components/Stage/utils';
import { getStyleOverrides } from 'components/Stage/StyleOverrides/SEAPages';

const StageBackGround = styled('div')(({ theme }) => ({
  background: `linear-gradient(0deg, #f7f7f7 0%, rgba(247, 247, 247, 0) 100%)`,
  padding: `${theme.spacing(3)} 0 ${theme.spacing(2)} 0`,
  [theme.breakpoints.up('md')]: {
    padding: `${theme.spacing(8)} 0 ${theme.spacing(4)}`,
  },
}));

const LandingPage = () => {
  const theme = useTheme();

  // Default case - do not touch! Do not add AB tests here under any circumstances.
  return (
    <>
      <MetaHead follow={false} index={false} />

      <HeaderWithOptions
        hasLoginLink={false}
        hasNavigationMenu={false}
        hasPhoneBox={false}
      />
      <StageBackGround>
        <Stage
          subline="Vergleichen Sie unverbindlich, schnell und einfach."
          sellingPoint1="100 % kostenloser und SCHUFA-neutraler Kreditvergleich"
          sellingPoint2="Kredite von über 25 Banken mit Günstiger-Geht-Nicht-Garantie&#42;"
          listIcon={ListIcons.CHECK_MARKS}
          sellingPointsPosition={SellingPointsPosition.DOWN}
          showFeaturedPanel={true}
          styleOverrides={getStyleOverrides(theme)}
          additionalParams={{ context: 'affiliate' }}
        />
      </StageBackGround>
      <PartnerBanks />
      <TrustBanner title="Über 300.000 zufriedene Kunden seit 2007" />

      {/* @ts-ignore */}
      <Advantages {...advantages} />
      <CTAStepExplanations headline="So einfach geht's" />
      <LegalText>
        <b>Laufzeit</b>: Minimum 6 Monate, Maximum 120 Monate
        <br />
        <b>Zinssätze</b>: Minimum -0,40 % effektiver Jahreszins, Maximum 19,99 %
        effektiver Jahreszins
        <br />
        <b>Beispiel</b>: 2/3 aller Kunden erhalten: Nettodarlehensbetrag
        20.000,00 €, 60 Monate Laufzeit, 6,20 % effektiver Jahreszins, 6,03 %
        p.a. gebundener Sollzins, 60 mtl. Raten zu je 386,94 €, 23.216,38 €
        Gesamtbetrag, Solaris SE, Cuvrystr. 53, 10997 Berlin
      </LegalText>
      <Box pb={2}>
        <Divider />
      </Box>
      <BottomNavigationMap />
      <Footer />
    </>
  );
};

// We needed to switch this to server side rendering as the
// context would otherwise be buggy. This might be a nextjs issue
// export const getStaticProps = async (): Promise<
//   GetStaticPropsResult<PageProps>
// > => {

export const getServerSideProps = withOptimizelyProps(async () => {
  return {
    props: {},
  };
});

export default LandingPage;
